import { render } from "./Info1.vue?vue&type=template&id=386b37ba&scoped=true"
import script from "./Info1.vue?vue&type=script&lang=js"
export * from "./Info1.vue?vue&type=script&lang=js"

import "./Info1.vue?vue&type=style&index=0&id=386b37ba&scoped=true&lang=css"

import exportComponent from "C:\\Users\\fchristo.ETAGEN\\Documents\\Adam-Backend\\adam-aibackend\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-386b37ba"]])

export default __exports__